import React from 'react'
import Slider from 'react-slick';
import avatar1 from '../assets/images/avatar-6.png';
import avatar2 from '../assets/images/avatar-7.png';
import avatar3 from '../assets/images/avatar-3.png';
import avatar4 from '../assets/images/avatar-8.png';
import avatar5 from '../assets/images/avatar-9.png';
import star from '../assets/images/star.png';

function SampleNextArrow(props) {

	const { style, onClick } = props;
	return (
		<button style={{ ...style, display: "block", position: "absolute", top: "50%", right: "-25px" }}
			onClick={onClick} className="text-5xl text-pink-350 hover:opacity-90 transition-all">&gt;</button>
	);
}
function SamplePrevArrow(props) {
	const { style, onClick } = props;
	return (
		<button style={{ ...style, display: "block", position: "absolute", top: "50%", left: "-25px" }}
			onClick={onClick} className="text-5xl  text-pink-350 hover:opacity-90 transition-all">&lt;</button>
	);
}

export default function ClientsReviews() {
	return (
		<>
			<section className="my-16 py-10 text-center min-w-0 relative overflow-hidden">
				<h2 className="my-5 text-center text-3xl font-bold">Our Clients Reviews</h2>
				<div className="mx-auto px-16 lg:px-20 max-lg:px-8 max-md:px-3">
					<Slider
						dots={true}
						slidesToShow={1}
						slidesToScroll={2}
						autoplay={false}
						autoplaySpeed={3000}
						adaptiveHeight={false}
						centerMode={true}
						infinite={true}
						nextArrow={<SampleNextArrow />}
						prevArrow={<SamplePrevArrow />}
					>
						<article className="">
							<div className="flex flex-row justify-items-center items-baseline min-w-0">
								<img className="mx-auto flex-none h-full opacity-20" src={avatar4} alt="Avatar" />
								<img className="mx-auto flex-none h-24 w-24" src={avatar3} alt="Avatar" />
								<img className="mx-auto flex-none h-full opacity-20" src={avatar5} alt="Avatar" />
							</div>
							<h3 className="my-5 text-lg font-semibold">Mia S</h3>
							<p className="my-5 	text-wrap: wrap">I'm a fitness enthusiast, and I decided to try buying real likes. It genuinely helped increase engagement on my posts, motivating me to push my fitness journey further.</p>
							<div className="flex flex-row justify-center">
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
							</div>
						</article>
						<article className="px-10 lg:px-10 max-lg:px-8 max-md:px-3">
							<div className="flex flex-row justify-items-center items-baseline">

								<img className="mx-auto flex-none  opacity-20 h-16 w-16" src={avatar3} alt="Avatar" />
								<img className="mx-auto flex-none h-24 w-24 " src={avatar4} alt="Avatar" />
								<img className="mx-auto flex-none h-full opacity-20" src={avatar5} alt="Avatar" />

							</div>
							<h3 className="my-5 text-lg font-semibold">Natalie R.</h3>
							<p className="my-5 	text-wrap: wrap">I'm a foodie, and after buying likes, I noticed more people appreciating my culinary creations. It's been a great confidence booster!</p>
							<div className="flex flex-row justify-center">
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
							</div>
						</article>
						<article className="px-10 lg:px-10 max-lg:px-8 max-md:px-3">
							<div className="flex flex-row justify-items-center items-baseline">
								<img className="mx-auto flex-none h-full opacity-20" src={avatar3} alt="Avatar" />
								<img className="mx-auto flex-none h-24 w-24 " src={avatar5} alt="Avatar" />
								<img className="mx-auto flex-none  opacity-20 h-16 w-16" src={avatar4} alt="Avatar" />

							</div>
							<h3 className="my-5 text-lg font-semibold">Kate J.</h3>
							<p className="my-5 	text-wrap: wrap">The Instagram algorithm is not working in our favor at the moment. Looking for alternative solutions I found this service and it made a massive change to my profile! Love it!</p>
							<div className="flex flex-row justify-center">
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
								<img className="flex-none" src={star} alt="star" />
							</div>
						</article>

					</Slider>
				</div>
			</section>
		</>
	)
}
